import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import StatusesServices from "./Statuses.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getStatus = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_STATUS,
      payload: true,
    });
    const resp = await StatusesServices.getStatus(filters);
    dispatch({
      type: actions.GET_STATUS,
      payload: {
        statuses: resp.data.data,
        statusesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.STATUS_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.STATUS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_STATUS,
      payload: false,
    });
  }
};

export const getStatusById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_STATUS,
      payload: true,
    });
    const resp = await StatusesServices.getStatusByID(id);
    dispatch({
      type: actions.GET_STATUS,
      payload: {
        statuses: resp.data,
      },
    });
    dispatch({
      type: actions.STATUS_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.STATUS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_STATUS,
      payload: false,
    });
  }
};

export const saveStatus =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_STATUS,
        payload: true,
      });
      const resp = await StatusesServices.saveStatus(data);
      const { statuses, statusesLength } = getState().planCarreraStatus;
      const _statuses = [...statuses, resp.data];
      dispatch({
        type: actions.GET_STATUS,
        payload: {
          statuses: _statuses,
          statusesLength: statusesLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_STATUS,
        payload: false,
      });
    }
  };

export const editStatus =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_STATUS,
        payload: true,
      });
      const resp = await StatusesServices.editStatus(id, data);
      const { statuses, statusesLength } = getState().planCarreraStatus;
      let _statuses = [...statuses]
      _statuses[index] = resp.data;
      dispatch({
        type: actions.GET_STATUS,
        payload: {
          statuses: _statuses,
          statusesLength: statusesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_STATUS,
        payload: false,
      });
    }
  };

export const deleteStatus = (id, index) => async (dispatch, getState) => {
  try {
   
    dispatch({
      type: actions.LOADING_STATUS,
      payload: true,
    });
    await StatusesServices.deleteStatus(id);
    const { statuses, statusesLength } = getState().planCarreraStatus;
    let _statuses = [...statuses]
    _statuses.splice(index, 1);
    dispatch({
      type: actions.GET_STATUS,
      payload: {
        statuses: _statuses,
        statusesLength: statusesLength - 1,
      },
    });
    dispatch({
      type: actions.STATUS_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;                         
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.STATUS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_STATUS,
      payload: false,
    });
  }
};
